/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Report status */
export enum ReportStatus {
  Draft,
  Generated,
  Reviewed,
  Approved,
  Submitted,
  Acknowledged,
  Rejected,
}

export type ReportStatusArgs = ReportStatus;

export function getReportStatusEncoder(): FixedSizeEncoder<ReportStatusArgs> {
  return getEnumEncoder(ReportStatus);
}

export function getReportStatusDecoder(): FixedSizeDecoder<ReportStatus> {
  return getEnumDecoder(ReportStatus);
}

export function getReportStatusCodec(): FixedSizeCodec<
  ReportStatusArgs,
  ReportStatus
> {
  return combineCodec(getReportStatusEncoder(), getReportStatusDecoder());
}
